import React, { useState } from "react";
import { Modal } from "antd";

// Obtener los pictogramas cargados
export const pictogramPaths = {
    1: require("../../pictures/pictograms/1.dib"),
    2: require("../../pictures/pictograms/2.dib"),
    3: require("../../pictures/pictograms/3.dib"),
    4: require("../../pictures/pictograms/4.dib"),
    5: require("../../pictures/pictograms/5.dib"),
    6: require("../../pictures/pictograms/6.dib"),
    7: require("../../pictures/pictograms/7.dib"),
    8: require("../../pictures/pictograms/8.dib"),
    9: require("../../pictures/pictograms/9.dib"),
    10: require("../../pictures/pictograms/10.dib"),
    11: require("../../pictures/pictograms/11.dib"),
    12: require("../../pictures/pictograms/12.dib"),
    13: require("../../pictures/pictograms/13.dib"),
    14: require("../../pictures/pictograms/14.dib"),
    15: require("../../pictures/pictograms/15.dib"),
    16: require("../../pictures/pictograms/16.dib"),
    17: require("../../pictures/pictograms/17.dib"),
    18: require("../../pictures/pictograms/18.dib"),
    19: require("../../pictures/pictograms/19.dib"),
    20: require("../../pictures/pictograms/20.dib"),
    21: require("../../pictures/pictograms/21.dib"),
    22: require("../../pictures/pictograms/22.dib"),
    23: require("../../pictures/pictograms/23.dib"),
    24: require("../../pictures/pictograms/24.dib"),
    25: require("../../pictures/pictograms/25.dib"),
    26: require("../../pictures/pictograms/26.dib"),
    27: require("../../pictures/pictograms/27.dib"),
    28: require("../../pictures/pictograms/28.dib"),
    29: require("../../pictures/pictograms/29.dib"),
    30: require("../../pictures/pictograms/30.dib"),
    31: require("../../pictures/pictograms/31.dib"),
    32: require("../../pictures/pictograms/32.dib"),
    33: require("../../pictures/pictograms/33.dib"),
    34: require("../../pictures/pictograms/34.dib"),
    35: require("../../pictures/pictograms/35.dib"),
    36: require("../../pictures/pictograms/36.dib"),
    37: require("../../pictures/pictograms/37.dib"),
    38: require("../../pictures/pictograms/38.dib"),
    39: require("../../pictures/pictograms/39.dib"),
    40: require("../../pictures/pictograms/40.dib"),
    41: require("../../pictures/pictograms/41.dib"),
    42: require("../../pictures/pictograms/42.dib"),
    43: require("../../pictures/pictograms/43.dib"),
    44: require("../../pictures/pictograms/44.dib"),
    45: require("../../pictures/pictograms/45.dib"),
    46: require("../../pictures/pictograms/46.dib"),
    47: require("../../pictures/pictograms/47.dib"),
    48: require("../../pictures/pictograms/48.dib"),
    49: require("../../pictures/pictograms/49.dib"),
    50: require("../../pictures/pictograms/50.dib"),
    51: require("../../pictures/pictograms/51.dib"),
    52: require("../../pictures/pictograms/52.dib"),
    53: require("../../pictures/pictograms/53.dib"),
    54: require("../../pictures/pictograms/54.dib"),
    55: require("../../pictures/pictograms/55.dib"),
    56: require("../../pictures/pictograms/56.dib"),
    57: require("../../pictures/pictograms/57.dib"),
    58: require("../../pictures/pictograms/58.dib"),
    59: require("../../pictures/pictograms/59.dib"),
    60: require("../../pictures/pictograms/60.dib"),
    61: require("../../pictures/pictograms/61.dib"),
    62: require("../../pictures/pictograms/62.dib"),
    63: require("../../pictures/pictograms/63.dib"),
    64: require("../../pictures/pictograms/64.BMP"),
    65: require("../../pictures/pictograms/65.dib"),
    66: require("../../pictures/pictograms/66.dib"),
    67: require("../../pictures/pictograms/67.dib"),
    68: require("../../pictures/pictograms/68.dib"),
    69: require("../../pictures/pictograms/69.dib"),
    70: require("../../pictures/pictograms/70.dib"),
    71: require("../../pictures/pictograms/71.dib"),
    72: require("../../pictures/pictograms/72.dib"),
    73: require("../../pictures/pictograms/73.dib"),
    74: require("../../pictures/pictograms/74.dib"),
    75: require("../../pictures/pictograms/75.dib"),
    76: require("../../pictures/pictograms/76.dib"),
    77: require("../../pictures/pictograms/77.dib"),
    78: require("../../pictures/pictograms/78.dib"),
    79: require("../../pictures/pictograms/79.dib"),
    80: require("../../pictures/pictograms/80.dib"),
    81: require("../../pictures/pictograms/81.dib"),
    82: require("../../pictures/pictograms/82.dib"),
    83: require("../../pictures/pictograms/83.dib"),
    84: require("../../pictures/pictograms/84.dib"),
    85: require("../../pictures/pictograms/85.dib"),
    86: require("../../pictures/pictograms/86.dib"),
    87: require("../../pictures/pictograms/87.dib"),
    88: require("../../pictures/pictograms/88.dib"),
    89: require("../../pictures/pictograms/89.dib"),
    90: require("../../pictures/pictograms/90.dib"),
    91: require("../../pictures/pictograms/91.dib"),
    92: require("../../pictures/pictograms/92.dib"),
    93: require("../../pictures/pictograms/93.dib"),
    94: require("../../pictures/pictograms/94.dib"),
    95: require("../../pictures/pictograms/95.dib"),
    96: require("../../pictures/pictograms/96.dib"),
    97: require("../../pictures/pictograms/97.dib"),
    98: require("../../pictures/pictograms/98.dib"),
    99: require("../../pictures/pictograms/99.dib"),
    100: require("../../pictures/pictograms/100.dib"),
    101: require("../../pictures/pictograms/101.dib"),
    102: require("../../pictures/pictograms/102.dib"),
    103: require("../../pictures/pictograms/103.dib"),
    104: require("../../pictures/pictograms/104.dib"),
    105: require("../../pictures/pictograms/105.dib"),
    106: require("../../pictures/pictograms/106.dib"),
    107: require("../../pictures/pictograms/107.dib"),
    108: require("../../pictures/pictograms/108.dib"),
    109: require("../../pictures/pictograms/109.dib"),
    110: require("../../pictures/pictograms/110.dib"),
    111: require("../../pictures/pictograms/111.dib"),
    112: require("../../pictures/pictograms/112.dib"),
    113: require("../../pictures/pictograms/113.dib"),
    114: require("../../pictures/pictograms/114.dib"),
    115: require("../../pictures/pictograms/115.dib"),
    116: require("../../pictures/pictograms/116.dib"),
    117: require("../../pictures/pictograms/117.dib"),
    118: require("../../pictures/pictograms/118.dib"),
    119: require("../../pictures/pictograms/119.dib"),
    120: require("../../pictures/pictograms/120.dib"),
    121: require("../../pictures/pictograms/121.BMP"),
    122: require("../../pictures/pictograms/122.dib"),
    123: require("../../pictures/pictograms/123.dib"),
    124: require("../../pictures/pictograms/124.dib"),
    125: require("../../pictures/pictograms/125.dib"),
    126: require("../../pictures/pictograms/126.dib"),
    127: require("../../pictures/pictograms/127.dib"),
    128: require("../../pictures/pictograms/128.dib"),
    129: require("../../pictures/pictograms/129.dib"),
    130: require("../../pictures/pictograms/130.dib"),
    131: require("../../pictures/pictograms/131.dib"),
    132: require("../../pictures/pictograms/132.dib"),
    133: require("../../pictures/pictograms/133.dib"),
    134: require("../../pictures/pictograms/134.dib"),
    135: require("../../pictures/pictograms/135.dib"),
    136: require("../../pictures/pictograms/136.dib"),
    137: require("../../pictures/pictograms/137.dib"),
    138: require("../../pictures/pictograms/138.dib"),
    139: require("../../pictures/pictograms/139.dib"),
    140: require("../../pictures/pictograms/140.dib"),
    141: require("../../pictures/pictograms/141.dib"),
    142: require("../../pictures/pictograms/142.dib"),
    143: require("../../pictures/pictograms/143.dib"),
    144: require("../../pictures/pictograms/144.dib"),
    145: require("../../pictures/pictograms/145.dib"),
    146: require("../../pictures/pictograms/146.dib"),
    147: require("../../pictures/pictograms/147.dib"),
    148: require("../../pictures/pictograms/148.dib"),
    149: require("../../pictures/pictograms/149.dib"),
    150: require("../../pictures/pictograms/150.dib"),
    151: require("../../pictures/pictograms/151.dib"),
    152: require("../../pictures/pictograms/152.dib"),
    153: require("../../pictures/pictograms/153.dib"),
    154: require("../../pictures/pictograms/154.dib"),
    155: require("../../pictures/pictograms/155.dib"),
    156: require("../../pictures/pictograms/156.dib"),
    157: require("../../pictures/pictograms/157.dib"),
    158: require("../../pictures/pictograms/158.dib"),
    159: require("../../pictures/pictograms/159.dib"),
    160: require("../../pictures/pictograms/160.dib"),
    161: require("../../pictures/pictograms/161.dib"),
    162: require("../../pictures/pictograms/162.dib"),
    163: require("../../pictures/pictograms/163.dib"),
    164: require("../../pictures/pictograms/164.dib"),
    165: require("../../pictures/pictograms/165.dib"),
    166: require("../../pictures/pictograms/166.dib"),
    167: require("../../pictures/pictograms/167.dib"),
    168: require("../../pictures/pictograms/168.dib"),
    169: require("../../pictures/pictograms/169.dib"),
    170: require("../../pictures/pictograms/170.dib"),
    171: require("../../pictures/pictograms/171.dib"),
    172: require("../../pictures/pictograms/172.dib"),
    173: require("../../pictures/pictograms/173.dib"),
    174: require("../../pictures/pictograms/174.BMP"),
    175: require("../../pictures/pictograms/175.dib"),
    176: require("../../pictures/pictograms/176.dib"),
    177: require("../../pictures/pictograms/177.dib"),
    178: require("../../pictures/pictograms/178.dib"),
    179: require("../../pictures/pictograms/179.dib"),
    180: require("../../pictures/pictograms/180.dib"),
    181: require("../../pictures/pictograms/181.dib"),
    182: require("../../pictures/pictograms/182.dib"),
    183: require("../../pictures/pictograms/183.dib"),
    184: require("../../pictures/pictograms/184.dib"),
    185: require("../../pictures/pictograms/185.dib"),
    186: require("../../pictures/pictograms/186.dib"),
    187: require("../../pictures/pictograms/187.dib"),
    188: require("../../pictures/pictograms/188.dib"),
    189: require("../../pictures/pictograms/189.dib"),
    190: require("../../pictures/pictograms/190.dib"),
    191: require("../../pictures/pictograms/191.dib"),
    192: require("../../pictures/pictograms/192.dib"),
    193: require("../../pictures/pictograms/193.dib"),
    194: require("../../pictures/pictograms/194.dib"),
    195: require("../../pictures/pictograms/195.dib"),
    196: require("../../pictures/pictograms/196.dib"),
    197: require("../../pictures/pictograms/197.dib"),
    198: require("../../pictures/pictograms/198.dib"),
    199: require("../../pictures/pictograms/199.dib"),
    200: require("../../pictures/pictograms/200.dib"),
    201: require("../../pictures/pictograms/201.dib"),
    202: require("../../pictures/pictograms/202.dib"),
    203: require("../../pictures/pictograms/203.dib"),
    204: require("../../pictures/pictograms/204.dib"),
    205: require("../../pictures/pictograms/205.dib"),
    206: require("../../pictures/pictograms/206.dib"),
    207: require("../../pictures/pictograms/207.dib"),
    208: require("../../pictures/pictograms/208.dib"),
    209: require("../../pictures/pictograms/209.dib"),
    210: require("../../pictures/pictograms/210.dib"),
    211: require("../../pictures/pictograms/211.dib"),
    212: require("../../pictures/pictograms/212.dib"),
    213: require("../../pictures/pictograms/213.dib"),
    214: require("../../pictures/pictograms/214.dib"),
    215: require("../../pictures/pictograms/215.dib"),
    216: require("../../pictures/pictograms/216.dib"),
    217: require("../../pictures/pictograms/217.dib"),
    218: require("../../pictures/pictograms/218.dib"),
    219: require("../../pictures/pictograms/219.dib"),
    220: require("../../pictures/pictograms/220.dib"),
    221: require("../../pictures/pictograms/221.dib"),
    222: require("../../pictures/pictograms/222.dib"),
    223: require("../../pictures/pictograms/223.dib"),
    244: require("../../pictures/pictograms/244.dib"),
    251: require("../../pictures/pictograms/251.dib"),
    252: require("../../pictures/pictograms/252.dib"),
    253: require("../../pictures/pictograms/253.dib"),
    254: require("../../pictures/pictograms/254.dib"),
};

interface PictogramSelectorProps {
    index: number;
    aspect: {
        pictogram: string;
    };
    handlePictogramChange: (index: number, pictogram: string) => void;
}

const PictogramSelector: React.FC<PictogramSelectorProps> = ({ index, aspect, handlePictogramChange }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    // Selección de pictograma
    const selectPictogram = (pictogram: string) => {
        handlePictogramChange(index, pictogram);
        closeModal();
    };

    return (
        <>
            <label htmlFor={`pictogramSelect-${index}`}>Pictograma</label>
            <div
                id={`pictogramSelect-${index}`}
                onClick={openModal}
                style={{ width: "100%", padding: "0px", height: "100%", cursor: "pointer" }}
            >
                {aspect.pictogram === "none" ? "..." : <img src={aspect.pictogram} alt="pictogram" style={{ width: "110px", height: "110px" }} />}
            </div>

            <Modal
                title="Seleccionar Pictograma"
                open={isModalOpen}
                onCancel={closeModal}
                footer={null}
                centered
            >
                <div style={{ display: "flex", justifyContent: "space-around", flexWrap: "wrap", gap: "10px", overflowY: "auto", height: "70vh"}}>
                    {Object.entries(pictogramPaths).map(([name, path]) => (
                        <div key={name} onClick={() => selectPictogram(path)} style={{ cursor: "pointer" }}>
                            <img src={path} alt={name} style={{ width: "50px", height: "50px" }} />
                        </div>
                    ))}
                </div>
            </Modal>
        </>
    );
};

export default PictogramSelector;
